import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";

import { IVisibilityLevel } from "../model/VisibilityLevel";
import VisibilityLevelParamMapper from "../service/VisibilityLevelParamMapper";

export default class AddDocumentTypeVisibilityLevelsInteractor {
  private createListResource: CreateListResourceInteractor<IVisibilityLevel>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(path: string, visibilityLevelListList: IVisibilityLevel[]) {
    return this.createListResource.execute(
      path,
      visibilityLevelListList,
      undefined,
      VisibilityLevelParamMapper
    );
  }
}
